export function getNotificationType(item) {
  const typeRaw =
    item?.notificationType ?? item?.NotificationType ?? item?.type;
  const typeNum = Number(typeRaw);
  if (typeNum === 2) return 2;
  const typeStr = String(typeRaw ?? "").toLowerCase();
  if (typeStr === "2" || typeStr === "notification") return 2;
  return 1;
}

export function normalizeTodayNotificationList(raw) {
  const list = Array.isArray(raw) ? raw : [];
  return list.map((item) => ({
    ...item,
    id: item?.id ?? item?.Id,
    notificationDate: item?.notificationDate ?? item?.NotificationDate,
    notificationTitle:
      item?.notificationTitle ?? item?.NotificationTitle ?? "",
    notificationText: item?.notificationText ?? item?.NotificationText ?? "",
    notificationType: getNotificationType(item),
  }));
}

export function getTodayPopupSeenStorageKey() {
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, "0");
  const d = String(today.getDate()).padStart(2, "0");
  return `todayNotificationPopupSeenIds_${y}-${m}-${d}`;
}

export function clearTodayNotificationPopupSeenIds() {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key === "todayNotificationPopupSeenIds" ||
      key.startsWith("todayNotificationPopupSeenIds_")
    ) {
      sessionStorage.removeItem(key);
    }
  });
}
